import { render, staticRenderFns } from "./RoutineApprovalEmptyState.vue?vue&type=template&id=1597fe9e"
import script from "./RoutineApprovalEmptyState.vue?vue&type=script&lang=js"
export * from "./RoutineApprovalEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports